<template>
  <v-card outlined class="rounded-lg ordera-box-shadow" flat>
    <v-card-title class="font-weight-bold">
      <v-avatar color="primary" size="36" class="mr-3">
        <v-icon color="white">mdi-history</v-icon>
      </v-avatar>
      {{ $t("outage_history_title") }}
    </v-card-title>

    <v-card-text>
      <empty-state
        v-if="loading || !items.length"
        :loading="loading"
        icon="mdi-message-off-outline"
        :title="loading ? $t('outage_loading_messages') : $t('outage_no_history')"
      />

      <div v-else>
        <div
          v-for="item in items"
          :key="item.id"
          class="outage-item mb-3"
          :class="{ 'outage-item--active': item.is_active }"
        >
          <div :class="['outage-item__bar', item.is_active ? 'success' : 'grey lighten-2']"></div>
          <div class="outage-item__body">
            <div class="d-flex align-center flex-wrap" style="gap: 8px">
              <v-chip
                :color="item.is_active ? 'success' : 'grey lighten-1'"
                text-color="white"
                x-small
                label
              >
                {{ item.is_active ? $t("outage_status_active") : $t("outage_status_inactive") }}
              </v-chip>
              <span class="font-weight-medium">{{ item.title }}</span>
              <v-chip
                v-if="item.is_active && outageDaysActive(item.created_at) >= warningDays"
                color="warning"
                text-color="white"
                x-small
                label
              >
                <v-icon left x-small>mdi-alert</v-icon>
                {{ $t("outage_days_count", { days: outageDaysActive(item.created_at) }) }}
              </v-chip>
              <v-spacer></v-spacer>
              <span class="caption grey--text text--darken-1">
                <v-icon x-small>mdi-clock-outline</v-icon>
                {{ formatOutageDate(item.created_at) }}
              </span>
            </div>

            <div class="outage-item__message">{{ item.message }}</div>

            <div class="d-flex justify-end mt-2">
              <v-btn
                v-if="item.is_active"
                small
                text
                color="error"
                :loading="togglingId === item.id"
                :disabled="togglingId === item.id"
                @click="$emit('deactivate', item)"
              >
                {{ $t("deactivate") }}
              </v-btn>
              <v-btn
                v-else
                small
                outlined
                color="success"
                :loading="togglingId === item.id"
                :disabled="togglingId === item.id"
                @click="$emit('activate', item)"
              >
                {{ $t("activate") }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import hasOutageDate from "@/mixins/hasOutageDate";
import EmptyState from "@/components/global/EmptyState.vue";

export default {
  name: "OutageHistoryList",
  mixins: [hasOutageDate],
  components: {
    EmptyState,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    togglingId: {
      type: [Number, String],
      default: null,
    },
    warningDays: {
      type: Number,
      default: 7,
    },
  },
};
</script>

<style scoped>
.outage-item {
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  overflow: hidden;
  transition: box-shadow 0.15s ease;
}

.outage-item:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.outage-item--active {
  border-color: rgba(76, 175, 80, 0.5);
}

.outage-item__bar {
  width: 5px;
  flex-shrink: 0;
}

.outage-item__body {
  padding: 12px 16px;
  flex: 1;
  min-width: 0;
}

.outage-item__message {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  margin-top: 4px;
}
</style>
